import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-data-protection-authoring-tools',
  templateUrl: './data-protection-authoring-tools.component.html',
  styleUrls: ['./data-protection-authoring-tools.component.scss']
})
export class DataProtectionAuthoringToolsComponent {
  constructor(private keycloakservice: KeycloakService,private router: Router ){}
  sidebarActive: boolean = true;
  user='';
  async ngOnInit(){
    const userInfo = await this.keycloakservice.loadUserProfile();
    this.user = userInfo?.username || null; 
  }
  
  dashboard(){
    this.router.navigate(['data-protection/auth-tools']);
  }

  truncate(){
    this.router.navigate(['data-protection/auth-tools/truncate/search']);
  }
  mask(){
    this.router.navigate(['data-protection/auth-tools/mask/search']);
  }
  hash(){
    this.router.navigate(['data-protection/auth-tools/hash/search']);
  }
  tokenize(){
    this.router.navigate(['data-protection/auth-tools/tokenize/search']);
  }
  anonymize(){
    this.router.navigate(['data-protection/auth-tools/anonymize/search']);
  }
  eliminate(){
    this.router.navigate(['data-protection/auth-tools/eliminate/search']);
  }
  encryption(){
    this.router.navigate(['data-protection/auth-tools/encryption/search']);
  }
   assetinfo(){
    this.router.navigate(['data-protection/auth-tools/asset/search']);
   }


  logout(): void{
    this.keycloakservice.logout( environment.keyCloakRedirectUrl);
  }
  back(){
    this.router.navigate(['data-protection']);
  }
}
